// src/pages/ScanSelectionPage.tsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import '../Styles/ScanSelectionPage.css';

const ScanSelectionPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState('all');

  const scanOptions = [
    {
      id: 'tuberculosis',
      title: 'Tuberculosis',
      description: 'AI-powered TB screening',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
          <path d="M17 7h-4v2h4c1.65 0 3 1.35 3 3s-1.35 3-3 3h-4v2h4c2.76 0 5-2.24 5-5s-2.24-5-5-5zm-6 8H7c-1.65 0-3-1.35-3-3s1.35-3 3-3h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-2zm-3-4h8v2H8z"/>
        </svg>
      ),
      color: '#F59E0B',
      category: 'respiratory'
    },
    {
      id: 'malaria',
      title: 'Malaria Scan',
      description: 'Detection of malaria parasites',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2c-2.21 0-4 1.79-4 4 0 1.07.43 2.03 1.12 2.73-1.93 1.26-3.25 3.36-3.25 5.73 0 3.31 2.69 6 6 6s6-2.69 6-6c0-2.37-1.32-4.47-3.25-5.73.69-.7 1.12-1.66 1.12-2.73 0-2.21-1.79-4-4-4zm0 2c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm0 14c-2.21 0-4-1.79-4-4 0-1.68 1.04-3.12 2.5-3.7.44.99 1.4 1.7 2.5 1.7s2.06-.71 2.5-1.7c1.46.58 2.5 2.02 2.5 3.7 0 2.21-1.79 4-4 4z"/>
        </svg>
      ),
      color: '#10B981',
      category: 'blood'
    },
   
    {
      id: 'xray',
      title: 'X-Ray Analysis',
      description: 'Comprehensive analysis of chest X-rays',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
          <path d="M21 5c-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5V6c-.6-.45-1.25-.75-2-1zm0 13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5 1.2 0 2.4.15 3.5.5v11.5z"/>
        </svg>
      ),
      color: '#3B82F6',
      category: 'imaging'
    },
   
    {
      id: 'cancer',
      title: 'Cancer Screening',
      description: 'Early cancer detection',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.2 3.2.8-1.3-4.5-2.7V7z"/>
        </svg>
      ),
      color: '#EF4444',
      category: 'oncology'
    },
    {
      id: 'fracture',
      title: 'Fracture Detection',
      description: 'Bone fracture identification',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
          <path d="M20.57 14.86L22 13.43 20.57 12 17 15.57 8.43 7 12 3.43 10.57 2 9.14 3.43 7.71 2 5.57 4.14 4.14 2.71 2.71 4.14l1.43 1.43L2 7.71l1.43 1.43L2 10.57 3.43 12 7 8.43 15.57 17 12 20.57 13.43 22l1.43-1.43L16.29 22l2.14-2.14 1.43 1.43 1.43-1.43-1.43-1.43L22 16.29z"/>
        </svg>
      ),
      color: '#8B5CF6',
      category: 'imaging'
    },
    {
      id: 'brain',
      title: 'Brain Scan',
      description: 'CT and MRI analysis',
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
          <path d="M13 3C9.23 3 6.19 5.95 6 9.66l-1.92 2.53c-.24.31 0 .81.42.81H6v3c0 1.11.89 2 2 2h1v3h7v-4.69c2.37-1.12 4-3.5 4-6.31 0-3.87-3.13-7-7-7m0 5c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"/>
        </svg>
      ),
      color: '#EC4899',
      category: 'neurology'
    }
  ];

  const categories = [
    { id: 'all', name: 'All Scans' },
    { id: 'imaging', name: 'Imaging' },
    { id: 'blood', name: 'Blood Tests' },
    { id: 'respiratory', name: 'Respiratory' },
    { id: 'oncology', name: 'Oncology' },
    { id: 'neurology', name: 'Neurology' }
  ];

  const filteredScans = activeTab === 'all' 
    ? scanOptions 
    : scanOptions.filter(scan => scan.category === activeTab);

  return (
    <div className="scan-selection-container">
      <div className="scan-header">
        <h1>Medical Scan Analysis</h1>
        <p>Select the type of scan you want to analyze</p>
      </div>

      <div className="category-tabs">
        {categories.map(category => (
          <button
            key={category.id}
            className={`tab ${activeTab === category.id ? 'active' : ''}`}
            onClick={() => setActiveTab(category.id)}
          >
            {category.name}
          </button>
        ))}
      </div>

      <div className="scan-grid">
        {filteredScans.map((scan) => (
          <Link 
            to={`/dashboard/${scan.id}`} 
            key={scan.id}
            className="scan-card"
          >
            <div className="scan-card-icon" style={{ color: scan.color }}>
              {scan.icon}
            </div>
            <div className="scan-card-content">
              <h3>{scan.title}</h3>
              <p>{scan.description}</p>
            </div>
            <div className="scan-card-arrow">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"/>
              </svg>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default ScanSelectionPage;